import { executeRequest, JFSRequest } from '@jfs/network'
import { clean, formatDate, isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    content: data?.content?.map((item: any) => {
      const getDuration = () => {
        let ret = ''
        const from = new Date(item.uploadedFrom).getTime()
        const to = item.uploadedTo ? new Date(item.uploadedTo).getTime() : Date.now()
        if (isNaN(from) || isNaN(to)) {
          return 'NA'
        }
        const dur = to - from
        const durInDays = dur / (24 * 60 * 60 * 1000)
        const remDur = dur % (24 * 60 * 60 * 1000)
        ret = ret + `D:${Math.floor(durInDays)}`

        const durInHrs = remDur / (60 * 60 * 1000)
        ret = ret + ` H:${Math.floor(durInHrs)}`
        const remDur1 = remDur % (60 * 60 * 1000)

        const durInMins = remDur1 / (60 * 1000)
        ret = ret + ` M:${Math.floor(durInMins)}`
        const remDur2 = remDur1 % (60 * 1000)

        const durInSecs = remDur2 / 1000
        ret = ret + ` S:${Math.floor(durInSecs)}`

        return ret
      }
      return {
        id: item.id ?? 0,
        fileName: item.savedFileName,
        fromDate: formatDate(item.uploadedFrom),
        toDate: formatDate(item.uploadedTo),
        duration: getDuration(),
        status: item?.isActive ? 'ACTIVATED' : 'DEACTIVATED',
        link: item.filePath,
        uploadedBy: item.createdBy,
        originalFileName: item.originalFileName,
        savedFileName: item.savedFileName,
      }
    }),
  }
}

const getAllFiles = (data: any, paginationInfo: any, fileType: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getAllFiles),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      inputFilter: {
        ...clean(data),
        fileType: fileType,
        ...(data?.isActive && { isActive: data?.isActive === 'ACTIVATED' ? true : false }),
      },
      configParams: paginationInfo,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllFiles }
